import { render, staticRenderFns } from "./DocumentSide.vue?vue&type=template&id=75696858&scoped=true&"
import script from "./DocumentSide.vue?vue&type=script&lang=js&"
export * from "./DocumentSide.vue?vue&type=script&lang=js&"
import style0 from "./DocumentSide.vue?vue&type=style&index=0&id=75696858&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75696858",
  null
  
)

export default component.exports